import React from "react";
const MonitoringContext = React.createContext(undefined);
export default MonitoringContext;
